import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// Import components
const LoginPage = () => import('@/pages/LoginPage.vue')
const AdminLayout = () => import('@/components/layout/AdminLayout.vue')
const DashboardPage = () => import('@/pages/DashboardPage.vue')
const StaffPage = () => import('@/pages/StaffPage.vue')
const AlertsPage = () => import('@/pages/AlertsPage.vue')
const CeoStaffPage = () => import('@/pages/CeoStaffPage.vue')
const CeoCustomersPage = () => import('@/pages/CeoCustomersPage.vue')

// Admin pages

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { 
      requiresGuest: true,
      title: 'Đăng nhập'
    }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { 
      requiresAuth: true 
    },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardPage,
        meta: { 
          title: 'Tổng quan',
          permission: 'view-dashboard'
        }
        },
      {
        path: 'staff',
        name: 'Staff',
        component: StaffPage,
        meta: {
          title: 'Nhân viên',
          permission: 'view-staff'
        }
      },
      {
        path: 'alerts',
        name: 'Alerts',
        component: AlertsPage,
        meta: {
          title: 'Alerts',
          permission: 'view-alerts'
        }
      },
      {
        path: 'ceo-staff',
        name: 'CeoStaff',
        component: CeoStaffPage,
        meta: {
          title: 'CEO - Staff',
          permission: 'view-ceo-staff'
        }
      },
      {
        path: 'ceo-customers',
        name: 'CeoCustomers',
        component: CeoCustomersPage,
        meta: {
          title: 'CEO - Customers',
          permission: 'view-ceo-customers'
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // Set page title
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE || 'Ads Management'}`
  }

  // Check authentication requirement
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authStore.isLoggedIn) { console.log('not logged in');
      next({ 
        path: '/login', 
        query: { redirect: to.fullPath } 
      })
      return
    }else {
        next();
    }
  }else {
      next();
  }
})

// Handle navigation errors
router.onError((error) => {
  console.error('Router error:', error)
})

export default router
